import { Link } from 'react-router-dom';
import { articles, Article } from '@/mocks/articles';

const latestArticles = articles.slice(3);

export default function LatestUpdates() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
          最新更新
        </h2>
        <p className="text-sm text-foreground-600">
          持续收录优质纲手同人创作，每周都有新内容
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {latestArticles.map((article: Article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-full h-44 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-white text-xs rounded-full font-medium">
                {article.category}
              </span>
            </div>
            <div className="p-4 flex flex-col flex-1">
              <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed flex-1">
                {article.excerpt}
              </p>
              <div className="flex flex-wrap items-center gap-2 mb-3">
                {article.tags.slice(0, 3).map((tag) => (
                  <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="flex items-center justify-between text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                <span>{article.author}</span>
                <span>{article.date}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}